import { render, staticRenderFns } from "./courseItems.vue?vue&type=template&id=8ed882da"
import script from "./courseItems.vue?vue&type=script&lang=js"
export * from "./courseItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports